export default __webpack_public_path__ + "static/media/star.65f672de.svg";